module.exports = __webpack_public_path__ + "media/icons/twitter-ccac41d4.svg";